<template>
    <div class="fullHeight">
        <MypageSideMenu @set="initialize" :memberDropClose="true"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-point mypage-title-icon"
            >
            <div class="col-sm-12">
                <div class="graywindow">
                    <div class="row justify-content-start m-3">
                        <div class="col-sm-5" v-if="select_point_use">
                            <select
                                class="form-control"
                                v-model="get_golf_code"
                                @change="ChangeGolfCode"
                                v-if="select_point_use"
                            >
                                <option
                                    v-for="data in get_point_use_type"
                                    :key="data.golf_code"
                                    :value="data.golf_code"
                                >
                                    {{ data.golf_name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="my-3 messageBox row row-notMx justify-content-around">
                        <div class="col-sm-3 align-self-center">
                            <div class="circle-container">
                                <div class="mypage-circle-content">保有ポイント</div>
                                <div class="mypage-point-circle">{{ this.total_points.toLocaleString() }}pt</div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div>
                                <div class="my-2">
                                    <div class="row row-notMx justify-content-between">
                                        <div>通常ポイント</div>
                                        <div class="font-weight-bold">{{ this.total_normal.toLocaleString() }}pt</div>
                                    </div>
                                    <div class="row row-notMx">
                                        <small v-if="this.min_valid_date_limited_normal">（最短有効期限：{{ this.min_valid_date_limited_normal | date_format_ja('-') }}）</small>
                                    </div>
                                    <div class="mypage-gray-border-bottom pt-1"></div>
                                </div>
                                <div class="my-2">
                                    <div class="row row-notMx justify-content-between">
                                        <div>期間限定ポイント</div>
                                        <div class="font-weight-bold">{{ this.total_limited.toLocaleString() }}pt</div>
                                    </div>
                                    <div class="row row-notMx">
                                        <small v-if="this.min_valid_date_limited">（最短有効期限：{{ this.min_valid_date_limited | date_format_ja('-') }}）</small>
                                    </div>
                                    <div class="mypage-gray-border-bottom pt-1"></div>
                                </div>
                                <div class="my-2">
                                    <div class="row row-notMx justify-content-between">
                                        <div>利用予定ポイント</div>
                                        <div class="font-weight-bold">{{ this.total_reserve.toLocaleString() }}pt</div>
                                    </div>
                                    <div class="row row-notMx">
                                        <small v-if="this.play_date">（直近利用予定：{{ this.play_date | date_format_ja('-') }}）</small>
                                    </div>
                                    <div class="mypage-gray-border-bottom pt-1"></div>
                                </div>
                                <div class="mb-4 mt-2">
                                    <div class="row row-notMx justify-content-between">
                                        <div>獲得予定ポイント</div>
                                        <div class="font-weight-bold">{{ this.total_expected.toLocaleString() }}pt</div>
                                    </div>
                                    <div class="row row-notMx">
                                        <small v-if="this.expected_date">（直近獲得予定：{{ this.expected_date | date_format_ja('-') }}）</small>
                                    </div>
                                    <div class="mypage-gray-border-bottom pt-1 mb-2"></div>
                                </div>
                            </div>
                            <div>
                                <button
                                    type="button"
                                    class="bluebackbutton btn-md btn-block"
                                    v-on:click="BackMyPage()">期限付きポイント一覧を見る
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="messageBox mypage-gray-border-top py-3">
                            <h5 class="font-weight-bold text-center mb-4">ポイント履歴</h5>
                            <table class="table table-striped mypage-table">
                                <thead class="sp_not">
                                    <tr>
                                        <th class="min-width-35 max-width-35" scope="col">取引日</th>
                                        <th class="min-width-35" scope="col">内容</th>
                                        <th class="min-width-15" scope="col">区分</th>
                                        <th class="text-right" scope="col">ポイント</th>
                                        <th class="min-width-75" scope="col">コメント</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="data in use_point_history" :key="data.id">
                                        <td class="date-cell d-flex justify-content-between d-sm-block">
                                            <span class="sp_label">取引日</span>
                                            <span class="font-weight-bold">{{ data.processing_date | date_format_ja('-') }}</span>
                                        </td>
                                        <td class="max-width-50 min-width-50 comment-cell justify-content-between">
                                            <div class="sp_label">内容</div>
                                            <div style="height: 100%;" class="font-weight-bold text-right">{{ data.action }}</div>
                                        </td>
                                        <td class="type-cell justify-content-between">
                                            <div class="sp_label">区分</div>
                                            <div class="font-weight-bold text-right float-right">{{ data.point_type_display }}</div>
                                        </td>
                                        <td :class="fontColor(data)" class="justify-content-between point-cell">
                                            <div class="sp_label">ポイント</div>
                                            <div class="font-weight-bold text-right float-right">{{ data.point.toLocaleString() }}</div>
                                        </td>
                                        <td class="min-width-50 comment-cell justify-content-between">
                                            <div class="sp_label">コメント</div>
                                            <div style="height: 100%;" class="font-weight-bold text-right">{{ data.comment }}</div>
                                        </td>
                                    </tr>
                                    <!-- <tr v-if="!this.display_point_history.length">
                                        <td colspan="4">ポイント履歴はありません</td>
                                    </tr> -->
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul class="pagination pagination-sm">
                                    <li class="page-item" @click="ClickPagination('History', 'Previous')">
                                        <span class="framebutton Mypagepoint_pagelinkwidth py-1">前へ</span>
                                    </li>
                                    <li class="pagination-center">
                                        <span>{{ display_pagination }} / {{ max_pagination }}</span>
                                    </li>
                                    <li class="page-item" @click="ClickPagination('History', 'Next')">
                                        <span class="framebutton Mypagepoint_pagelinkwidth py-1">次へ</span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
        <MypageFooter
            @out-click="logOutBtn"
        />
        <MypageMenuFooter/>
    </div>
</template>

<script>
import {
    GET_POINT_HISTORY,
    GET_GOLF_COURSE_POINT_HISTORY
} from '../../constants/mypage_point';
import {
    GET_MYPAGE_POINT_INFO
} from '../../constants/mypage_top';
import { MEMBER_LOG_OUT } from "../../constants/signout";
import MypageSideMenu from './MypageSideMenu';
import MypageHeader from './MypageHeader';
import MypageFooter from './MypageFooter';
import { memberStatusMixin } from './memberStatusMixin';
import Card from '../components/Card';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        MypageHeader,
        MypageFooter,
        Card
    },
    mixins: [memberStatusMixin],
    data () {
        return {
            // ページタイトル
            page_title: 'ポイント照会',
            classBlack: 'text-body',
            classRed: 'text-danger',
            point_use_type_group: 1,
            point_use_type_golf: 2,
            member_no: '',
            use_golf_code: '',
            golf_group_code: process.env.MIX_GROUP_CODE,
            total_points: 0,
            total_normal: 0,
            total_limited: 0,
            total_expected: 0,
            total_reserve: 0,
            get_golf_code: '',
            select_point_use: false,
            // ゴルフ場グループに基くゴルフ場データ
            get_point_use_type: [],
            // 取得したポイント履歴データ格納
            use_point_history: [],
            // 表示するポイント履歴データ格納
            display_point_history: [],
            display_history_begin_row: 0,
            // ポイント履歴表示レコード数
            display_history_limit_rows: 7,
            // 表示中のポイント履歴ページネーション数
            display_pagination: 1,
            // ポイント履歴最大ページネーション数
            max_pagination: 1,
            point_use_type: '',
            point_flag_normal: 1,
            point_flag_limited_normal: 2,
            point_flag_limited: 3,
            min_valid_date_limited_normal: '',
            min_valid_date_limited: '',
            expected_date: '',
            play_date: ''
        };
    },
    created () {
        this.initialize();
    },
    watch: {
        display_pagination: function (now) {
            this.display_point_history = [];
            const nextNum = now * this.display_history_limit_rows;
            for (var i = nextNum - this.display_history_limit_rows; i < nextNum; i++) {
                if (this.use_point_history[i] !== undefined) {
                    this.display_point_history.push(this.use_point_history[i])
                }
            }
        }
    },
    computed: {
        disabledPagination () {
            return this.max_pagination === 0 || this.max_pagination === 1;
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.$store.commit("loading/setIsLoading", true);
            this.GetLoginUserMemberStatus();
            this.member_no = this.$store.state.auth.loginMember.member_no;
            this.full_name = this.$store.state.auth.loginMember.family_name + ' ' + this.$store.state.auth.loginMember.given_name;
            await this.getMypagePointInfo();
            this.$store.commit("loading/setIsLoading", false);
        },
        /** ----------------------------------------------
         * ポイント履歴取得
         * ---------------------------------------------- */
        getMypagePointInfo: async function () {
             await this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_MYPAGE_POINT_INFO,
                variables: {
                    golf_group_code: this.golf_group_code,
                    member_no: this.member_no,
                    point_type: null,
                    history_begin_row: this.display_history_begin_row,
                    history_limit_rows: this.display_history_limit_rows,
                    display_flag: 1
                }
            }).then(res => {
                if (res.data.getMypagePointInfo.pointUseType !== null) {
                    this.select_point_use = true;
                    this.get_point_use_type = res.data.getMypagePointInfo.pointUseType;
                    this.point_use_type = this.point_use_type_golf;
                    if (this.$store.state.mypage.useGolfCode !== null){
                        this.use_golf_code = this.$store.state.mypage.useGolfCode;
                    }else{
                        this.use_golf_code = this.get_point_use_type[0].golf_code;
                    }
                    this.get_golf_code = this.use_golf_code;
                    this.$store.commit('mypage/useGolfCode', this.get_golf_code);
                } else {
                    this.select_point_use = false;
                    this.point_use_type = this.point_use_type_group;
                }

                // ポイントの合計値取得
                if (!res.data.getMypagePointInfo.totalPoint.total_all) {
                    this.total_points = 0;
                    this.total_normal = 0;
                    this.total_limited = 0;
                    this.min_valid_date_limited_normal = '';
                    this.min_valid_date_limited = '';
                } else {
                    this.total_points = res.data.getMypagePointInfo.totalPoint.total_all;
                    this.total_normal = res.data.getMypagePointInfo.totalPoint.total_normal;
                    this.total_limited = res.data.getMypagePointInfo.totalPoint.total_limited;
                    this.min_valid_date_limited_normal = res.data.getMypagePointInfo.validDate.total_limited_normal;
                    this.min_valid_date_limited = res.data.getMypagePointInfo.validDate.total_limited;
                }
                if (!res.data.getMypagePointInfo.totalPoint.total_expected) {
                    this.total_expected = 0;
                    this.expected_date = '';
                } else {
                    this.total_expected = res.data.getMypagePointInfo.totalPoint.total_expected;
                    this.expected_date = res.data.getMypagePointInfo.validDate.expected_date;
                }
                if (!res.data.getMypagePointInfo.totalPoint.total_reserve) {
                    this.total_reserve = 0;
                    this.play_date = '';
                } else {
                    this.total_reserve = res.data.getMypagePointInfo.totalPoint.total_reserve;
                    this.play_date = res.data.getMypagePointInfo.validDate.play_date;
                }

                this.use_point_history = res.data.getMypagePointInfo.pointList;
                if (res.data.getMypagePointInfo.count === 0) {
                    res.data.getMypagePointInfo.count = 1;
                }
                this.max_pagination = Math.ceil(res.data.getMypagePointInfo.count / this.display_history_limit_rows);
            })
        },
        /** ----------------------------------------------
         * ポイントがマイナス値の場合は赤字表示
         * ---------------------------------------------- */
        fontColor: function(data) {
            if (data.point < 0) {
                return this.classRed;
            } else {
                return this.classBlack;
            }
        },
        ClickPagination: function (target, mode) {
            // ポイント履歴のページネーションクリック時の処理
            if (target === 'History') {
                // 前へボタン押下時処理
                if (mode === 'Previous') {
                    if (this.display_pagination > 1) {
                        this.display_pagination--;
                        if (this.display_pagination === 1) {
                            this.display_history_begin_row = 0;
                        } else {
                            this.display_history_begin_row = this.display_history_begin_row - this.display_history_limit_rows;
                        }
                        this.getPointHistory();
                    } else {
                        return;
                    }
                } else {
                    // 次へボタン押下時処理
                    if (this.display_pagination < this.max_pagination) {
                        this.display_history_begin_row = this.display_history_begin_row + this.display_history_limit_rows;
                        this.display_pagination++;
                        this.getPointHistory();
                    } else {
                        return;
                    }
                }
            }
        },

        ChangeGolfCode: async function () {
            this.total_points = '0';
            this.display_point_history = [];
            this.display_pagination = 1;
            this.max_pagination = 1;
            this.$store.commit("loading/setIsLoading", true);
            this.$store.commit('mypage/useGolfCode', this.get_golf_code);
            this.ChangeGolfPointHistory();
            this.$store.commit("loading/setIsLoading", false);
        },
        getPointHistory: function () {
            this.use_point_history = [];
            this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_POINT_HISTORY,
                variables: {
                    golf_group_code: process.env.MIX_GROUP_CODE,
                    golf_code: this.get_golf_code,
                    point_type: null,
                    history_begin_row: this.display_history_begin_row,
                    history_limit_rows: this.display_history_limit_rows,
                    display_flag: 1
                }
            }).then(res => {
                this.use_point_history = res.data.memberGetPointList.PointList;
                if (res.data.memberGetPointList.count === 0) {
                    res.data.memberGetPointList.count = 1;
                }
                this.max_pagination = Math.ceil(res.data.memberGetPointList.count / this.display_history_limit_rows);
            })
        },
        ChangeGolfPointHistory: async function() {
            await this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_GOLF_COURSE_POINT_HISTORY,
                variables: {
                    member_no: this.member_no,
                    golf_group_code: process.env.MIX_GROUP_CODE,
                    golf_code: this.get_golf_code,
                    point_type: null,
                    history_begin_row: this.display_history_begin_row,
                    history_limit_rows: this.display_history_limit_rows,
                    display_flag: 1
                }
            }).then(res => {
                // ポイントの合計値取得
                if (!res.data.getGolfCoursePointHistory.totalPoint.total_all) {
                    this.total_points = 0;
                    this.total_normal = 0;
                    this.total_limited = 0;
                    this.min_valid_date_limited_normal = '';
                    this.min_valid_date_limited = '';
                } else {
                    this.total_points = res.data.getGolfCoursePointHistory.totalPoint.total_all;
                    this.total_normal = res.data.getGolfCoursePointHistory.totalPoint.total_normal;
                    this.total_limited = res.data.getGolfCoursePointHistory.totalPoint.total_limited;
                    this.min_valid_date_limited_normal = res.data.getGolfCoursePointHistory.validDate.total_limited_normal;
                    this.min_valid_date_limited = res.data.getGolfCoursePointHistory.validDate.total_limited;
                }
                if (!res.data.getGolfCoursePointHistory.totalPoint.total_expected) {
                    this.total_expected = 0;
                    this.expected_date = '';
                } else {
                    this.total_expected = res.data.getGolfCoursePointHistory.totalPoint.total_expected;
                    this.expected_date = res.data.getGolfCoursePointHistory.validDate.expected_date;
                }
                if (!res.data.getGolfCoursePointHistory.totalPoint.total_reserve) {
                    this.total_reserve = 0;
                    this.play_date = '';
                } else {
                    this.total_reserve = res.data.getGolfCoursePointHistory.totalPoint.total_reserve;
                    this.play_date = res.data.getGolfCoursePointHistory.validDate.play_date;
                }

                this.use_point_history = res.data.getGolfCoursePointHistory.pointList;
                if (res.data.getGolfCoursePointHistory.count === 0) {
                    res.data.getGolfCoursePointHistory.count = 1;
                }
                this.max_pagination = Math.ceil(res.data.getGolfCoursePointHistory.count / this.display_history_limit_rows);
            })
        },
        BackMyPage: function (){
            // マイページトップ画面へ遷移
            this.$router.push({ path: '/mypage-point-top' });
        },
        logOutBtn: function () {
            this.$store.commit("loading/setIsLoading", true);
            this.$store.commit("mypage/useGolfCode", null);
            this.$apollo.query({
                query: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.$router.push('/');
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        }
    }
}

</script>

<style scoped>
.sp_label {
    min-width: 4rem;
}
</style>
